import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { Modal, WhiteButton, Button } from 'components';
import { IConfirmationDialogProps } from 'models/modal';

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ConfirmationDialog extends React.Component<IConfirmationDialogProps, {}> {
	constructor(props) {
		super(props);

		this.confirmNo = this.confirmNo.bind(this);
		this.confirmYes = this.confirmYes.bind(this);
	}

	private confirmYes() {
		this.props.confirmAction(true, this.props.value);
	}

	private confirmNo() {
		this.props.confirmAction(false, this.props.value);
	}

	public render() {
		const { yesButtonText, noButtonText, content, title, customFooterContent } = this.props;

		const footer = (
			<div className="buttonContainer d-flex justify-content-center flex-wrap">
				{customFooterContent ? (
					customFooterContent
				) : (
					<>
						<WhiteButton onClick={this.confirmNo}>{noButtonText}</WhiteButton>
						<Button onClick={this.confirmYes}>{yesButtonText}</Button>
					</>
				)}
			</div>
		);

		return (
			<Modal
				modalClass={`confirmationDialogModal modalSmall ${
					this.props?.customModalClassName ? this.props.customModalClassName : ''
				}`}
				title={title ? title : ''}
				showHeaderCloseButton={true}
				closeModal={this.confirmNo}
				size={'small'}
				footer={footer}
			>
				<div className="d-flex flex-column align-items-center">{content}</div>
			</Modal>
		);
	}
}
export { ConfirmationDialog };
